import { Component, HostListener, OnDestroy, OnInit  } from '@angular/core';

import 'leaflet/dist/images/layers.png';
import 'leaflet/dist/images/layers-2x.png';
import 'leaflet/dist/images/marker-shadow.png';
import 'leaflet/dist/images/marker-icon.png';
import 'leaflet/dist/images/marker-icon-2x.png';
import { TranslateService } from '@ngx-translate/core';
import { PreviousRouteService } from '../services/previous-router.service';
// import { AppToastService } from '../services/toast.service';

import { icon, Marker } from 'leaflet';
import { environment } from 'src/environments/environment';
const iconRetinaUrl = 'assets/marker-icon-2x.png';
const iconUrl = 'assets/marker-icon.png';
const shadowUrl = 'assets/marker-shadow.png';
const iconDefault = icon({
  iconRetinaUrl,
  iconUrl,
  shadowUrl,
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  tooltipAnchor: [16, -28],
  shadowSize: [41, 41]
});
Marker.prototype.options.icon = iconDefault;

@Component({
  selector: 'app-root',
  template: `
    <router-outlet></router-outlet>
    <app-toasts aria-live="polite" aria-atomic="true"></app-toasts>
  `,
  host: {
    class: environment.projectName == 'R2S' ? '' : 'app-main'
  }
})
export class AppComponent implements OnDestroy, OnInit {
  title = 'r2s';

  constructor(
    public translater: TranslateService,
    routingState: PreviousRouteService,
    // public toastService: AppToastService
  ) {
    const browserLang = this.translater.getBrowserLang();
    const supportedLanguages = JSON.parse(environment.supportedLanguages);
    const matchedLang = supportedLanguages.find(
      lang => lang.langJson === browserLang || lang.lang.toLowerCase() === browserLang
    );
    const selectedLang =  (matchedLang ? matchedLang.langJson : (supportedLanguages.find(lang => lang.lang === "EN") || supportedLanguages[0]).langJson).toUpperCase();
    localStorage.setItem('user_lng',selectedLang)
    this.translater.use(selectedLang);
    this.translater.setDefaultLang(selectedLang);
    routingState.loadRouting();
  }
  ngOnInit(): void {
    this.updateFavicon(environment.projectName);
    this.updateTitle(environment.projectName);
  }
  updateFavicon(projectName: string) {
    const faviconPath = `assets/img/${projectName.toLowerCase()}.png`;
    const faviconElement = document.getElementById('app-favicon') as HTMLLinkElement;
    if (faviconElement) {
      faviconElement.href = faviconPath;
    }
  }
  updateTitle(projectName: string) {
    document.title = projectName;
  }
  ngOnDestroy(): void {
    // this.toastService.clear();
  }
}
